<template>
    <div class="follow-up-template-management">
      <h2 class="page-title">随访计划模板管理</h2>
      
      <!-- 搜索区域 -->
      <el-card class="search-card">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="模板名称">
            <el-input v-model="searchForm.templateName" placeholder="请输入模板名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="执行科室">
            <el-select v-model="searchForm.department" placeholder="请选择科室" clearable>
              <el-option label="全部" value="all"></el-option>
              <el-option label="内科" value="内科"></el-option>
              <el-option label="外科" value="外科"></el-option>
              <el-option label="妇产科" value="妇产科"></el-option>
              <el-option label="儿科" value="儿科"></el-option>
              <el-option label="眼科" value="眼科"></el-option>
              <el-option label="骨科" value="骨科"></el-option>
              <el-option label="神经内科" value="神经内科"></el-option>
              <el-option label="心内科" value="心内科"></el-option>
              <el-option label="肿瘤科" value="肿瘤科"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划类型">
            <el-select v-model="searchForm.planType" placeholder="请选择计划类型" clearable>
              <el-option label="随访计划" value="followUp"></el-option>
              <el-option label="健康指导计划" value="healthGuidance"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="基准日期">
            <el-select v-model="searchForm.baseDate" placeholder="请选择基准日期" clearable>
              <el-option
                v-for="item in baseDateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      
      <!-- 操作按钮区域 -->
      <div class="operation-container">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增模板</el-button>
        <el-button type="danger" icon="el-icon-delete" :disabled="multipleSelection.length === 0" @click="handleBatchDelete">批量删除</el-button>
        <el-button type="success" icon="el-icon-upload2" @click="handleImport">导入</el-button>
        <el-button type="warning" icon="el-icon-download" @click="handleExport">导出</el-button>
      </div>
      
      <!-- 表格区域 -->
      <el-table
        ref="templateTable"
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="60">
        </el-table-column>
        <el-table-column
          prop="templateName"
          label="模板名称"
          min-width="180"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="planType"
          label="计划类型"
          width="120">
          <template slot-scope="scope">
            <el-tag 
              size="medium" 
              :type="scope.row.planType === '随访计划' ? 'primary' : 'success'">
              {{ scope.row.planType }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="department"
          label="执行科室"
          width="100">
          <template slot-scope="scope">
            <el-tag size="medium" :type="scope.row.department === '全部' ? 'info' : ''">{{ scope.row.department }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="period"
          label="周期(天)"
          width="90">
        </el-table-column>
        <el-table-column
          prop="baseDate"
          label="基准日期"
          width="110">
          <template slot-scope="scope">
            <el-tag size="small" type="success">{{ scope.row.baseDate }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="taskCount"
          label="任务数"
          width="80">
          <template slot-scope="scope">
            <el-badge :value="scope.row.tasks.length" class="task-badge">
              <el-button size="mini" type="text" @click="viewTasks(scope.row)">查看</el-button>
            </el-badge>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="170">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              active-text="启用"
              inactive-text="停用"
              @change="handleStatusChange(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="260">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="info" icon="el-icon-document-copy" @click="handleCopy(scope.row)">复制</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页区域 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
      
      <!-- 新增/编辑模板对话框 -->
      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
        <el-form :model="templateForm" :rules="templateRules" ref="templateForm" label-width="100px">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="基本信息" name="basicInfo">
              <el-form-item label="模板名称" prop="templateName">
                <el-input v-model="templateForm.templateName" placeholder="请输入模板名称"></el-input>
              </el-form-item>
              <el-form-item label="计划类型" prop="planType">
                <el-radio-group v-model="templateForm.planType">
                  <el-radio label="随访计划">随访计划</el-radio>
                  <el-radio label="健康指导计划">健康指导计划</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="执行科室" prop="department">
                <el-select v-model="templateForm.department" placeholder="请选择科室" style="width: 100%">
                  <el-option label="全部" value="全部"></el-option>
                  <el-option label="内科" value="内科"></el-option>
                  <el-option label="外科" value="外科"></el-option>
                  <el-option label="妇产科" value="妇产科"></el-option>
                  <el-option label="儿科" value="儿科"></el-option>
                  <el-option label="眼科" value="眼科"></el-option>
                  <el-option label="骨科" value="骨科"></el-option>
                  <el-option label="神经内科" value="神经内科"></el-option>
                  <el-option label="心内科" value="心内科"></el-option>
                  <el-option label="肿瘤科" value="肿瘤科"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="周期(天)" prop="period">
                <el-input-number v-model="templateForm.period" :min="1" :max="1000" style="width: 200px"></el-input-number>
              </el-form-item>
              <el-form-item label="基准日期" prop="baseDate">
                <el-select v-model="templateForm.baseDate" placeholder="请选择基准日期" style="width: 100%">
                  <el-option
                    v-for="item in baseDateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="执行时间" prop="executionTime.type">
                <el-radio-group v-model="templateForm.executionTime.type">
                  <el-radio label="immediate">立即执行</el-radio>
                  <el-radio label="delay">延迟执行</el-radio>
                </el-radio-group>
                <div v-if="templateForm.executionTime.type === 'delay'" style="margin-top: 10px">
                  <span>从基准日期起第</span>
                  <el-input-number v-model="templateForm.executionTime.days" :min="0" :max="100" style="width: 120px"></el-input-number>
                  <span>天开始执行</span>
                </div>
              </el-form-item>
              <el-form-item label="状态">
                <el-switch
                  v-model="templateForm.status"
                  active-text="启用"
                  inactive-text="停用">
                </el-switch>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="templateForm.remark" :rows="3" placeholder="请输入备注信息"></el-input>
              </el-form-item>
            </el-tab-pane>
            
            <el-tab-pane label="任务设置" name="taskSetting">
              <div class="task-setting-header">
                <div class="header-title">随访任务配置</div>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="addTask">新增任务</el-button>
              </div>
              
              <div class="tasks-container">
                <el-collapse v-model="activeTaskPanel">
                  <el-collapse-item v-for="(task, index) in templateForm.tasks" :key="index" :name="'task' + index">
                    <template slot="title">
                      <div class="task-title">
                        <span class="task-day">第{{ task.day }}天</span>
                        <span class="task-content-preview">{{ task.content.length > 30 ? task.content.substring(0, 30) + '...' : task.content }}</span>
                      </div>
                    </template>
                    
                    <div class="task-item">
                      <el-form-item :label="'第几天'" :prop="'tasks.' + index + '.day'" :rules="{ required: true, message: '请输入任务执行天数', trigger: 'blur' }">
                        <el-input-number v-model="task.day" :min="1" :max="templateForm.period" style="width: 130px"></el-input-number>
                      </el-form-item>
                      
                      <el-form-item :label="'任务内容'" :prop="'tasks.' + index + '.content'" :rules="{ required: true, message: '请输入任务内容', trigger: 'blur' }">
                        <el-input type="textarea" v-model="task.content" :rows="3" placeholder="请输入任务内容描述"></el-input>
                      </el-form-item>
                      
                      <el-form-item label="执行角色">
                        <el-checkbox-group v-model="task.roles">
                          <el-checkbox label="患者">患者</el-checkbox>
                          <el-checkbox label="个管师">个管师</el-checkbox>
                          <el-checkbox label="医助">医助</el-checkbox>
                          <el-checkbox label="领衔专家">领衔专家</el-checkbox>
                          <el-checkbox label="执行医生">执行医生</el-checkbox>
                          <el-checkbox label="护士">护士</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                      
                      <div class="more-settings-container">
                        <el-divider content-position="left">更多设置</el-divider>
                        
                        <el-form-item label="推送用户">
                          <el-switch v-model="task.notification.enabled" active-text="是" inactive-text="否"></el-switch>
                        </el-form-item>
                        
                        <div v-if="task.notification.enabled" class="notification-settings">
                          <el-form-item label="短信通知">
                            <el-switch v-model="task.notification.sms.enabled" active-text="启用" inactive-text="禁用"></el-switch>
                          </el-form-item>
                          
                          <el-form-item v-if="task.notification.sms.enabled" label="短信模板">
                            <div class="template-input-container">
                              <el-input 
                                type="textarea" 
                                v-model="task.notification.sms.template" 
                                :rows="3" 
                                placeholder="请输入短信模板内容，可使用变量如${patient_name}"></el-input>
                              <div class="template-tips">
                                <div class="tips-title">模板变量说明：</div>
                                <div class="tips-item">${patient_name} - 患者姓名</div>
                                <div class="tips-item">${doctor_name} - 医生姓名</div>
                                <div class="tips-item">${hospital_name} - 医院名称</div>
                                <div class="tips-item">${task_day} - 任务天数</div>
                                <div class="tips-item">${date} - 当前日期</div>
                              </div>
                            </div>
                          </el-form-item>
                          
                          <el-form-item label="站内信通知">
                            <el-switch v-model="task.notification.internalMsg.enabled" active-text="启用" inactive-text="禁用"></el-switch>
                          </el-form-item>
                          
                          <el-form-item v-if="task.notification.internalMsg.enabled" label="站内信模板">
                            <div class="template-input-container">
                              <el-input 
                                type="textarea" 
                                v-model="task.notification.internalMsg.template" 
                                :rows="3" 
                                placeholder="请输入站内信模板内容，可使用变量如${patient_name}"></el-input>
                              <div class="template-tips">
                                <div class="tips-title">模板变量说明：</div>
                                <div class="tips-item">${patient_name} - 患者姓名</div>
                                <div class="tips-item">${doctor_name} - 医生姓名</div>
                                <div class="tips-item">${hospital_name} - 医院名称</div>
                                <div class="tips-item">${task_day} - 任务天数</div>
                                <div class="tips-item">${date} - 当前日期</div>
                                <div class="tips-item">${time} - 当前时间</div>
                              </div>
                            </div>
                          </el-form-item>
                        </div>
                      </div>
                      
                      <div class="task-actions">
                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeTask(index)" :disabled="templateForm.tasks.length <= 1">删除任务</el-button>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
      
      <!-- 任务查看对话框 -->
      <el-dialog title="随访任务列表" :visible.sync="taskDialogVisible" width="700px">
        <div class="task-list-header">
          <h4>{{ currentTemplate.templateName }}</h4>
          <div>周期：{{ currentTemplate.period }} 天，基准日期：{{ currentTemplate.baseDate }}</div>
        </div>
        
        <el-table
          :data="currentTemplate.tasks"
          border
          style="width: 100%">
          <el-table-column prop="day" label="天数" width="80"></el-table-column>
          <el-table-column prop="content" label="任务内容" min-width="250" show-overflow-tooltip></el-table-column>
          <el-table-column label="执行角色" width="200">
            <template slot-scope="scope">
              <el-tag v-for="(role, idx) in scope.row.roles" :key="idx" size="mini" style="margin-right: 5px">{{ role }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="通知配置" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.notification.enabled">
                <el-tag size="mini" type="success" v-if="scope.row.notification.sms.enabled">短信</el-tag>
                <el-tag size="mini" type="primary" v-if="scope.row.notification.internalMsg.enabled">站内信</el-tag>
              </div>
              <span v-else>未配置通知</span>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </template>
  <script>
  export default {
    name: 'FollowUpPlanManagement',
    data() {
      return {
        // 搜索表单
        searchForm: {
          templateName: '',
          department: '',
          planType: '',
          baseDate: ''
        },
        
        // 表格数据
        tableData: [],
        loading: false,
        multipleSelection: [],
        
        // 分页相关
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        },
        
        // 对话框相关
        dialogVisible: false,
        dialogTitle: '新增随访计划模板',
        taskDialogVisible: false,
        currentTemplate: {},
        
        // 编辑标签页
        activeTab: 'basicInfo',
        activeTaskPanel: ['task0'],
        
        // 模板表单
        templateForm: {
          id: '',
          templateName: '',
          planType: '随访计划',
          department: '',
          period: 30,
          baseDate: '',
          status: true,
          remark: '',
          executionTime: {
            type: 'immediate',
            days: 0
          },
          tasks: [
            {
              day: 1,
              content: '',
              roles: ['个管师'],
              notification: {
                enabled: false,
                sms: {
                  enabled: false,
                  template: ''
                },
                internalMsg: {
                  enabled: false,
                  template: ''
                }
              }
            }
          ]
        },
        
        // 表单验证规则
        templateRules: {
          templateName: [
            { required: true, message: '请输入模板名称', trigger: 'blur' },
            { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
          ],
          department: [
            { required: true, message: '请选择执行科室', trigger: 'change' }
          ],
          planType: [
            { required: true, message: '请选择计划类型', trigger: 'change' }
          ],
          period: [
            { required: true, message: '请输入周期天数', trigger: 'blur' }
          ],
          baseDate: [
            { required: true, message: '请选择基准日期', trigger: 'change' }
          ]
        },
        
        // 基准日期选项
        baseDateOptions: [
          { value: 'group_time', label: '入组时间' },
          { value: 'last_menstruation', label: '末次月经' },
          { value: 'birth_date', label: '出生日期' },
          { value: 'operation_date', label: '手术日期' },
          { value: 'discharge_date', label: '出院日期' },
          { value: 'diagnosis_date', label: '确诊日期' },
          { value: 'first_visit', label: '首次就诊' },
          { value: 'last_visit', label: '最近随访' },
          { value: 'custom_date', label: '自定义日期' }
        ]
      }
    },
    created() {
      this.fetchData();
    },
    methods: {
      // 获取数据
      fetchData() {
        this.loading = true;
        
        // 模拟API请求延迟
        setTimeout(() => {
          // 模拟随访计划模板数据
          const mockData = [
            {
              id: '1001',
              templateName: '孕产妇常规随访计划',
              planType: '随访计划',
              department: '妇产科',
              period: 280,
              baseDate: '末次月经',
              createTime: '2023-01-15 10:25:36',
              status: true,
              executionTime: {
                type: 'immediate',
                days: 0
              },
              tasks: [
                { 
                  day: 30, 
                  content: '产检：确认怀孕、建立孕妇健康档案',
                  roles: ['医助', '护士'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '尊敬的${patient_name}，您的产检预约时间为${date}，请按时前往${hospital_name}进行检查。'
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 70, 
                  content: '产检：肝功能、肾功能、血常规检查',
                  roles: ['执行医生', '护士'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '尊敬的${patient_name}，提醒您在第${task_day}天需要进行肝肾功能检查，请提前预约。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '患者${patient_name}需要在${date}进行肝肾功能检查，请做好准备。'
                    }
                  }
                },
                { 
                  day: 120, 
                  content: '产检：唐氏筛查、血常规、尿常规',
                  roles: ['执行医生'],
                  notification: {
                    enabled: false,
                    sms: {
                      enabled: false,
                      template: ''
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 180, 
                  content: '产检：糖筛、四维彩超、血常规',
                  roles: ['执行医生', '个管师'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '尊敬的${patient_name}，您的四维彩超预约时间为${date}，请按时前往医院。'
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 240, 
                  content: '产检：肝功能、肾功能、胎心监护',
                  roles: ['执行医生', '护士'],
                  notification: {
                    enabled: false,
                    sms: {
                      enabled: false,
                      template: ''
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 280, 
                  content: '产检：评估分娩时机、胎心监护',
                  roles: ['领衔专家', '执行医生'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '尊敬的${patient_name}，您即将临产，请密切关注宫缩情况，如有异常请立即就医。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '患者${patient_name}即将临产，请做好相关准备工作。'
                    }
                  }
                }
              ]
            },
            {
              id: '1002',
              templateName: '糖尿病随访管理计划',
              planType: '随访计划',
              department: '内科',
              period: 90,
              baseDate: '确诊日期',
              createTime: '2023-02-20 14:30:45',
              status: true,
              executionTime: {
                type: 'delay',
                days: 3
              },
              tasks: [
                { 
                  day: 7, 
                  content: '电话随访：血糖监测情况、用药情况',
                  roles: ['医助', '个管师'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，今天需要进行血糖监测，请记得按时用药并记录血糖值。'
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 15, 
                  content: '门诊随访：血糖检测、用药调整',
                  roles: ['执行医生'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，请于${date}前来复诊，进行血糖检测和用药调整。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '请提醒患者${patient_name}于${date}前来复诊，需要进行血糖检测和药物调整。'
                    }
                  }
                },
                { 
                  day: 30, 
                  content: '门诊随访：血糖监测、饮食运动指导',
                  roles: ['执行医生', '个管师'],
                  notification: {
                    enabled: false,
                    sms: {
                      enabled: false,
                      template: ''
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 60, 
                  content: '电话随访：血糖控制情况、并发症监测',
                  roles: ['医助', '护士'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，我们将在近期对您进行电话随访，了解您的血糖控制情况，请保持手机畅通。'
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 90, 
                  content: '门诊随访：血糖、糖化血红蛋白检查、综合评估',
                  roles: ['领衔专家', '执行医生'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，请于${date}前来医院进行糖化血红蛋白检查和综合评估。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '患者${patient_name}将于${date}进行糖化血红蛋白检查和糖尿病管理综合评估。'
                    }
                  }
                }
              ]
            },
            {
              id: '1003',
              templateName: '高血压管理计划',
              planType: '随访计划',
              department: '心内科',
              period: 180,
              baseDate: '入组时间',
              createTime: '2023-03-05 09:12:18',
              status: true,
              executionTime: {
                type: 'immediate',
                days: 0
              },
              tasks: [
                { 
                  day: 7, 
                  content: '电话随访：血压监测指导、用药情况',
                  roles: ['医助', '个管师'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，请每天定时测量血压并记录，按医嘱服用降压药物。'
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 30, 
                  content: '门诊随访：血压评估、用药调整',
                  roles: ['执行医生'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，请于${date}前来复诊，进行血压评估和用药调整。'
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 90, 
                  content: '线下随访：血压监测、心电图检查',
                  roles: ['执行医生', '护士'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，请于${date}前来医院进行心电图检查和血压评估。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '请通知${patient_name}于${date}来院进行心电图检查和血压评估。'
                    }
                  }
                },
                { 
                  day: 180, 
                  content: '综合评估：血压控制情况、用药调整、并发症筛查',
                  roles: ['领衔专家', '执行医生', '个管师'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，请于${date}前来医院进行高血压半年度综合评估。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '患者${patient_name}将于${date}进行高血压半年度综合评估，请做好准备。'
                    }
                  }
                }
              ]
            },
            {
              id: '1004',
              templateName: '术后康复指导计划',
              planType: '健康指导计划',
              department: '骨科',
              period: 60,
              baseDate: '手术日期',
              createTime: '2023-04-12 16:40:22',
              status: true,
              executionTime: {
                type: 'delay',
                days: 1
              },
              tasks: [
                { 
                  day: 1, 
                  content: '术后第一天指导：疼痛管理、伤口护理',
                  roles: ['护士', '执行医生'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，术后请注意休息，按医嘱用药，保持伤口清洁干燥。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '请关注患者${patient_name}术后恢复情况，注意疼痛管理和伤口观察。'
                    }
                  }
                },
                { 
                  day: 3, 
                  content: '术后活动指导：床上活动、站立练习',
                  roles: ['个管师', '护士'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，今天可以进行适当床上活动和站立练习，注意不要负重。'
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 7, 
                  content: '伤口复查：拆线评估、康复计划调整',
                  roles: ['执行医生', '护士'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，请于${date}前来医院进行伤口复查和拆线评估。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '患者${patient_name}将于${date}来院进行术后伤口复查和拆线评估。'
                    }
                  }
                },
                { 
                  day: 14, 
                  content: '康复训练指导：功能锻炼计划制定',
                  roles: ['个管师', '执行医生'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，请于${date}前来医院进行康复训练指导。'
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 30, 
                  content: '功能评估：关节活动度测量、肌力测试',
                  roles: ['执行医生'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，请于${date}前来医院进行术后一个月功能评估。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '请安排患者${patient_name}于${date}进行术后一个月功能评估。'
                    }
                  }
                },
                { 
                  day: 60, 
                  content: '综合评估：功能恢复情况、生活自理能力评定',
                  roles: ['领衔专家', '执行医生', '个管师'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '${patient_name}您好，请于${date}前来医院进行术后两月综合评估。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '患者${patient_name}将于${date}进行术后两月综合评估，请做好相关准备。'
                    }
                  }
                }
              ]
            },
            {
              id: '1005',
              templateName: '儿童疫苗接种计划',
              planType: '健康指导计划',
              department: '儿科',
              period: 365,
              baseDate: '出生日期',
              createTime: '2023-05-18 11:08:56',
              status: true,
              executionTime: {
                type: 'immediate',
                days: 0
              },
              tasks: [
                { 
                  day: 1, 
                  content: '新生儿乙肝疫苗第一针',
                  roles: ['护士', '执行医生'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '恭喜您喜得贵子/千金，请记得为宝宝接种出生第一天的乙肝疫苗。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '新生儿${patient_name}需要接种乙肝疫苗第一针，请准备。'
                    }
                  }
                },
                { 
                  day: 30, 
                  content: '一月龄检查、乙肝疫苗第二针',
                  roles: ['执行医生', '护士'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '您的宝宝即将满月，请于${date}带宝宝来院进行体检和接种乙肝疫苗第二针。'
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 90, 
                  content: '三月龄检查、脊灰疫苗第一针',
                  roles: ['执行医生', '护士'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '您的宝宝即将满3个月，请于${date}带宝宝来院进行体检和脊灰疫苗接种。'
                    },
                    internalMsg: {
                      enabled: false,
                      template: ''
                    }
                  }
                },
                { 
                  day: 180, 
                  content: '六月龄检查、麻风腮疫苗',
                  roles: ['执行医生', '护士'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '您的宝宝即将满6个月，请于${date}带宝宝来院进行体检和麻风腮疫苗接种。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '患儿${patient_name}将于${date}进行6月龄体检和麻风腮疫苗接种，请做好准备。'
                    }
                  }
                },
                { 
                  day: 365, 
                  content: '周岁体检、乙肝疫苗加强针',
                  roles: ['执行医生', '护士'],
                  notification: {
                    enabled: true,
                    sms: {
                      enabled: true,
                      template: '恭喜您的宝宝即将满1周岁，请于${date}带宝宝来院进行体检和接种乙肝疫苗加强针。'
                    },
                    internalMsg: {
                      enabled: true,
                      template: '患儿${patient_name}将于${date}进行周岁体检和乙肝疫苗加强针接种。'
                    }
                  }
                }
              ]
            }
          ];
          
          this.tableData = mockData;
          this.pagination.total = mockData.length;
          this.loading = false;
        }, 800);
      },
      
      // 搜索
      handleSearch() {
        this.pagination.currentPage = 1;
        this.fetchData();
        // 实际项目中这里应该调用筛选API
      },
      
      // 重置搜索
      resetSearch() {
        this.$refs.searchForm.resetFields();
        this.fetchData();
      },
      
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      
      // 分页大小改变
      handleSizeChange(val) {
        this.pagination.pageSize = val;
        this.fetchData();
      },
      
      // 当前页改变
      handleCurrentChange(val) {
        this.pagination.currentPage = val;
        this.fetchData();
      },
      
      // 查看任务列表
      viewTasks(row) {
        this.currentTemplate = JSON.parse(JSON.stringify(row));
        this.taskDialogVisible = true;
      },
      
      // 状态改变
      handleStatusChange(row) {
        const statusText = row.status ? '启用' : '停用';
        this.$message({
          message: `已${statusText}【${row.templateName}】随访计划模板`,
          type: 'success'
        });
        // 实际项目中这里应调用更新状态API
      },
      
      // 新增模板
      handleAdd() {
        this.dialogTitle = '新增随访计划模板';
        this.templateForm = {
          id: '',
          templateName: '',
          planType: '随访计划',
          department: '',
          period: 30,
          baseDate: '',
          status: true,
          remark: '',
          executionTime: {
            type: 'immediate',
            days: 0
          },
          tasks: [
            {
              day: 1,
              content: '',
              roles: ['个管师'],
              notification: {
                enabled: false,
                sms: {
                  enabled: false,
                  template: ''
                },
                internalMsg: {
                  enabled: false,
                  template: ''
                }
              }
            }
          ]
        };
        this.activeTab = 'basicInfo';
        this.activeTaskPanel = ['task0'];
        this.dialogVisible = true;
      },
      
      // 编辑模板
      handleEdit(row) {
        this.dialogTitle = '编辑随访计划模板';
        this.templateForm = JSON.parse(JSON.stringify(row));
        this.activeTab = 'basicInfo';
        this.activeTaskPanel = ['task0'];
        this.dialogVisible = true;
      },
      
      // 复制模板
      handleCopy(row) {
        this.dialogTitle = '复制随访计划模板';
        // 深拷贝以避免引用原对象
        const copy = JSON.parse(JSON.stringify(row));
        copy.id = '';
        copy.templateName = copy.templateName + ' - 副本';
        this.templateForm = copy;
        this.activeTab = 'basicInfo';
        this.activeTaskPanel = ['task0'];
        this.dialogVisible = true;
      },
      
      // 删除模板
      handleDelete(row) {
        this.$confirm(`确认删除随访计划模板【${row.templateName}】吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟API删除操作
          setTimeout(() => {
            this.tableData = this.tableData.filter(item => item.id !== row.id);
            this.pagination.total = this.tableData.length;
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }, 500);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      
      // 批量删除
      handleBatchDelete() {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请至少选择一个模板');
          return;
        }
        
        const names = this.multipleSelection.map(item => item.templateName).join('、');
        this.$confirm(`确认批量删除选中的 ${this.multipleSelection.length} 个随访计划模板吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟API删除操作
          setTimeout(() => {
            const ids = this.multipleSelection.map(item => item.id);
            this.tableData = this.tableData.filter(item => !ids.includes(item.id));
            this.pagination.total = this.tableData.length;
            this.$message({
              type: 'success',
              message: `成功删除 ${this.multipleSelection.length} 个模板!`
            });
            this.multipleSelection = [];
          }, 500);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      
      // 导入模板
      handleImport() {
        this.$message({
          message: '导入功能开发中...',
          type: 'info'
        });
      },
      
      // 导出模板
      handleExport() {
        this.$message({
          message: '导出功能开发中...',
          type: 'info'
        });
      },
      
      // 提交表单
      submitForm() {
        this.$refs.templateForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            
            // 模拟API保存操作
            setTimeout(() => {
              if (this.templateForm.id) {
                // 编辑模式
                const index = this.tableData.findIndex(item => item.id === this.templateForm.id);
                if (index !== -1) {
                  this.tableData[index] = JSON.parse(JSON.stringify(this.templateForm));
                }
                this.$message({
                  message: '修改成功！',
                  type: 'success'
                });
              } else {
                // 新增模式
                const newTemplate = JSON.parse(JSON.stringify(this.templateForm));
                newTemplate.id = 'T' + new Date().getTime();
                newTemplate.createTime = this.formatDateTime(new Date());
                this.tableData.unshift(newTemplate);
                this.pagination.total = this.tableData.length;
                this.$message({
                  message: '添加成功！',
                  type: 'success'
                });
              }
              
              this.dialogVisible = false;
              this.loading = false;
            }, 800);
          } else {
            return false;
          }
        });
      },
      
      // 添加任务
      addTask(index) {
        // 插入到指定索引后面，如果没有索引则添加到最后
        const newTask = {
          day: 1,
          content: '',
          roles: ['个管师'],
          notification: {
            enabled: false,
            sms: {
              enabled: false,
              template: ''
            },
            internalMsg: {
              enabled: false,
              template: ''
            }
          }
        };
        
        if (index !== undefined) {
          this.templateForm.tasks.splice(index + 1, 0, newTask);
          // 设置新添加的任务面板为展开状态
          this.activeTaskPanel.push('task' + (index + 1));
        } else {
          this.templateForm.tasks.push(newTask);
          // 设置新添加的任务面板为展开状态
          this.activeTaskPanel.push('task' + (this.templateForm.tasks.length - 1));
        }
      },
      
      // 删除任务
      removeTask(index) {
        if (this.templateForm.tasks.length <= 1) {
          this.$message.warning('至少需要保留一个任务');
          return;
        }
        
        this.templateForm.tasks.splice(index, 1);
        // 更新展开面板
        this.activeTaskPanel = this.activeTaskPanel.filter(item => item !== 'task' + index);
      },
      
      // 格式化日期时间
      formatDateTime(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    }
  }
  </script>

<style scoped>
.follow-up-template-management {
  padding: 15px;
}

.page-title {
  margin-bottom: 20px;
  color: #303133;
  font-weight: 600;
  font-size: 20px;
}

.search-card {
  margin-bottom: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.operation-container {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.task-badge {
  margin-right: 10px;
}

/* 对话框内样式 */
.task-setting-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.header-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.tasks-container {
  margin-top: 10px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  padding: 5px;
  background-color: #f9f9f9;
}

.task-title {
  display: flex;
  align-items: center;
}

.task-day {
  font-weight: bold;
  margin-right: 15px;
  color: #409EFF;
  min-width: 60px;
}

.task-content-preview {
  color: #606266;
  font-size: 14px;
}

.task-item {
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
}

.task-actions {
  text-align: right;
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px dashed #EBEEF5;
}

.more-settings-container {
  margin-top: 15px;
  background-color: #f8f8f8;
  padding: 10px 15px;
  border-radius: 4px;
}

.notification-settings {
  padding-left: 20px;
  margin-top: 10px;
  border-left: 2px solid #EBEEF5;
}

.template-input-container {
  display: flex;
  gap: 15px;
}

.template-tips {
  width: 220px;
  padding: 8px 12px;
  background-color: #f2f6fc;
  border-radius: 4px;
  color: #606266;
  font-size: 12px;
  line-height: 1.5;
}

.tips-title {
  font-weight: bold;
  margin-bottom: 5px;
  color: #303133;
}

.tips-item {
  margin-bottom: 3px;
}

/* 任务查看对话框 */
.task-list-header {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}

.task-list-header h4 {
  margin: 0 0 5px 0;
  color: #303133;
  font-size: 16px;
}

.dialog-footer {
  text-align: right;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .template-input-container {
    flex-direction: column;
  }
  
  .template-tips {
    width: 100%;
  }
  
  .el-form-item {
    margin-bottom: 18px;
  }
}

/* 表格中标签的样式调整 */
.el-tag + .el-tag {
  margin-left: 5px;
}

/* 表单底部按钮间距 */
.el-form-item__content .el-button + .el-button {
  margin-left: 10px;
}

/* 折叠面板样式优化 */
.el-collapse-item__header {
  padding: 10px;
  font-size: 14px;
  border-radius: 4px;
}

.el-collapse-item__wrap {
  border-radius: 0 0 4px 4px;
}

.el-collapse-item.is-active .el-collapse-item__header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: 1px solid #EBEEF5;
}

/* 多选框组样式调整 */
.el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

/* 开关样式微调 */
.el-switch__label {
  font-size: 13px;
}

/* 任务面板内的表单项紧凑显示 */
.task-item .el-form-item {
  margin-bottom: 15px;
}

/* 表格样式微调 */
.el-table .cell {
  line-height: 1.5;
}

/* 模板标题高亮 */
.el-table .cell .el-tooltip {
  font-weight: 500;
}
</style>